import { FileText } from "lucide-react";
import { useMeetingNote } from "@/hooks/useMeetingNotes";
import { matchContextPath } from "../match";
import type { ContextParams, NavContextDef, NavItem } from "../types";

export const meetingNotePath = (id: string) => `/meeting-notes/${id}`;

/**
 * Meeting notes without a project or group (D12). Notes of a project or group
 * live in that context under Notes; their page redirects there.
 */
function useMeetingNoteItems({ id }: ContextParams): NavItem[] {
  return [
    {
      key: "note",
      label: "Note",
      href: meetingNotePath(id),
      exact: true,
      icon: FileText,
    },
  ];
}

function useMeetingNoteHeader({ id }: ContextParams) {
  const { data: note } = useMeetingNote(id);
  if (!note) return {};
  return { kicker: "Meeting note", title: note.title || "Untitled" };
}

export const meetingNoteContext: NavContextDef = {
  type: "meeting-note",
  typeLabel: "Meeting note",
  icon: FileText,
  match: (pathname) =>
    matchContextPath("/meeting-notes/:id", pathname, {
      id: ["management", "new"],
    }),
  key: ({ id }) => `meeting-note:${id}`,
  base: ({ id }) => meetingNotePath(id),
  parent: () => ({ label: "Meeting notes", href: "/meeting-notes" }),
  useHeader: useMeetingNoteHeader,
  useItems: useMeetingNoteItems,
};
